import NonCompeteContainer from './non-compete-container';

export default NonCompeteContainer;
